import { isNull, isUndefined } from 'lodash/fp';
import React from 'react';

import { CustomTooltip } from '../tooltip';
import styles from './Table.module.scss';
import { Icon } from '../icon/Icon';
import { Engine } from '../icons';
import { Spinner } from '../spinner/Spinner';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const NettingAnalysisCell: React.FC<{ value: any; valueFormatted: string[]; }> = ({ value, valueFormatted }) => {
    if ((isUndefined(valueFormatted) && isUndefined(value)) || isNull(value)) {
        return null;
    }

    const iconColor = valueFormatted[0] || '';
    const tooltip = valueFormatted[1] || '';
    const isRecalculating = (valueFormatted[2] || '') === 'showSpinner';

    if (isRecalculating) {
        return (
            <CustomTooltip overlayText='Netting Analysis Calculating' placement='top'>
                <div className={styles.nettingAnalysisCellWrapper}>
                    <Spinner size={15} />
                </div>
            </CustomTooltip>
        );
    }

    return (
        <CustomTooltip overlayText={tooltip} placement='top'>
            <div className={styles.nettingAnalysisCellWrapper}>
                <Icon icon={Engine} color={iconColor} fontSize={20} />
            </div>
        </CustomTooltip>
    );
};
